import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import TransiluminatorWarning from '@learningblocks/exp-constants/lib/Images/transiluminator-warning.svg';

export function Warning({style}) {
  return (
    <Image
      src={TransiluminatorWarning}
      style={style}
      alt='transiluminator_warning'
    />
  );
}

Warning.propTypes = {
  /**
   * style to be set on component
   */
  style: PropTypes.object,
};
